<section class="custom_pad">
  <form name="form">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 form-group margin-left-30">
          <h4>Configure the quota tracking</h4>
          <div class="row">
            <div class="col-md-8">
              <label>
                Will a Panelist be able to satisfy multiple quota on this
                project
              </label>
            </div>
            <div class="col-md-4 softlaunch-toggle-btn">
              <p>No</p>
              <label class="status">
                <ps-ui-slider
                  id="check"
                  (selectedChange)="resetQlcAttributes()"
                  [(selected)]="
                    surveyDetails && surveyDetails.qlc.multiple_quotas.enable
                  "
                >
                </ps-ui-slider>
              </label>
              <p>Yes</p>
            </div>
          </div>
          <div
            *ngIf="
              surveyDetails &&
              surveyDetails.qlc &&
              surveyDetails.qlc.multiple_quotas.enable
            "
            class="row"
          >
            <div class="col-md-8">
              <label>Would you like Purespectrum to count completed by</label>
            </div>
            <div class="col-md-4 softlaunch-toggle-btn">
              <p>Survey Completed</p>
              <label class="status">
                <ps-ui-slider
                  [(selected)]="
                    surveyDetails.qlc.multiple_quotas.count_by_quota
                  "
                  (selectedChange)="setCompensateByQuota()"
                >
                </ps-ui-slider>
              </label>
              <p>Quota Satisfied</p>
            </div>
            <div class="col-md-8">
              <label>Would you like to compensate the Supplier per</label>
            </div>
            <div class="col-md-4 softlaunch-toggle-btn">
              <p>Survey Completed</p>
              <label class="status">
                <ps-ui-slider
                  [(selected)]="
                    surveyDetails.qlc.multiple_quotas.compensate_by_quota
                  "
                  [disabled]="!surveyDetails.qlc.multiple_quotas.count_by_quota"
                >
                </ps-ui-slider>
              </label>
              <p>Quota Satisfied</p>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 form-group margin-left-30">
          <h4>Confirmation</h4>
          <div class="col-md-8" class="text-left inline-checkbox-text">
            <input
              type="checkbox"
              name="isConfirmationChecked"
              class="me-1"
              [(ngModel)]="isConfirmationChecked"
            />
            <label>
              I agree to pay
              {{
                surveyDetails?.cpi?.current
                  | currency : surveyDetails?.currency_symbol
              }}

              for each
              {{
                surveyDetails?.qlc?.multiple_quotas?.compensate_by_quota
                  ? 'Quota Satisfied'
                  : 'Survey Completed'
              }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <!-- here to start -->
    <section class="pad">
      <div class="container">
        <div class="row">
          <div class="col-xs-8 col-sm-8 col-md-8">
            <h4 class="text-center">Quota Mapping</h4>
            <div class="row">
              <table
                class="table table-responsive table-bordered table-striped"
              >
                <thead>
                  <th class="col-md-4">Quota Description</th>
                  <th class="col-md-4">Quota Code to Map</th>
                </thead>
                <tbody>
                  <tr *ngFor="let quota of quotas; let index = index">
                    <td class="col-md-6">{{ getQuotaDescription(quota) }}</td>
                    <td class="col-md-6">
                      <form name="quotaForm">
                        <div class="row">
                          <div
                            class="form-group col-md-8"
                            [ngClass]="{
                              'has-error':
                                quota.uiIsDuplicate || quota.charCountExceeded
                            }"
                          >
                            <input
                              name="quotaName"
                              type="text"
                              class="form-control"
                              (keydown)="formatValidation($event)"
                              [(ngModel)]="quotas[index].buyer_quota_id"
                              (ngModelChange)="changeBuyerQuotaId()"
                            />
                          </div>
                          <div class="col-md-4">
                            <i
                              *ngIf="
                                quota.uiIsDuplicate || quota.charCountExceeded
                              "
                              class="fa fa-close quota-charcount"
                            ></i>
                          </div>
                        </div>
                      </form>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-xs-4 col-sm-4 col-md-4 quota-map-reminder">
            <div class="panel-group">
              <div class="quota-map-tooltop">
                <span>Quota Map Remainder </span>
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  (click)="setQuotaMapRemainder()"
                ></i>
              </div>
              <div
                *ngIf="isQuotaMapRemainder"
                class="panel panel-info"
                ng-class="{
                  'margin-bottom-10': !finalSurvey.qlc.isMultiQuotas
                }"
              >
                <div class="panel-heading">
                  When Setting up your quota maps please remember :
                </div>
                <div class="panel-body">
                  <ul class="list-style-type">
                    <li>Only Alphanumeric & Hyphen ("-").</li>
                    <li>No Space or Special Characters Except Hyphen.</li>
                    <li>Each Code must be unique to the project</li>
                    <li>Maximum 15 Characters per code.</li>
                    <li>PRO-TIP: Use abbreviations</li>
                  </ul>
                </div>
              </div>
              <div
                *ngIf="
                  isQuotaMapRemainder &&
                  surveyDetails.qlc.multiple_quotas.enable
                "
                class="panel panel-info panel-info-margin"
              >
                <div class="panel-heading">Also please note:</div>
                <div class="panel-body">
                  <ul class="list-style-type">
                    <li>Seperate quotas with a comma: ","</li>
                    <li>
                      Maximum amount of quotas that can be added to a
                      transaction is 10
                    </li>
                  </ul>
                </div>
              </div>
              <div class="quota-map-tooltop">
                <span>Transmitting Quotas </span>
                <i
                  class="fa fa-info-circle"
                  aria-hidden="true"
                  (click)="setTrasmittingQuotaMap()"
                ></i>
              </div>
              <div
                *ngIf="isTrasmittingQuotaMap"
                class="panel panel-info margin-top-10"
              >
                <div class="panel-heading">
                  When transmitting your quota codes please use the following
                  format:
                </div>
                <div class="panel-body">
                  <ul class="list-style-type">
                    <li>
                      surveydone?st=[%%STATUS%%]&amp;transaction_id=[%%TRANSACTION_ID%%]&amp;quota_id=[%%QUOTA_ID_1,QUOTA_ID_2%%]
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </form>
  <!-- Form Section ends -->
  <ps-ui-footer
    [buttonStatus]="footerButtonStatus"
    [surveyPayload]="surveyPayload"
    [currentPage]="'MAP_QUOTA'"
    [cpiAndCompensationConfirmed]="isConfirmationChecked"
  ></ps-ui-footer>
</section>
